// extracted by mini-css-extract-plugin
export default {"durationOrQuantityTextbox":"DosageDurationOrQuantityEditForm_durationOrQuantityTextbox__Pqgsf","hyperlinkContainer":"DosageDurationOrQuantityEditForm_hyperlinkContainer__Ep1vk"};